"use client";

import { Link, usePathname } from "@/i18n/routing";
import Image from "next/image";
import { useMemo } from "react";
import { useTranslations } from "next-intl";
import { useLivechat } from "@/components/contexts/live-chat";
import { cn } from "@heroui/react";
export default function NavbarBottom() {
  const t = useTranslations();
  const PageLinks = [
    { text: t("home"), link: "/", imageLink: "/bottom-navbar/v2-home.png" },
    { text: t("promotion"), link: "/promotion", imageLink: "/bottom-navbar/v2-promotion.png" },
    { text: t("wallet"), link: "/wallet", imageLink: "/bottom-navbar/v2-wallet.png" },
    { text: t("referral"), link: "/referral", imageLink: "/bottom-navbar/v2-referral.png" },
    { text: t("account"), link: "/profile", imageLink: "/bottom-navbar/v2-profile.png" },
  ];
  const pathname = usePathname();
  const { visibility, openLivechat } = useLivechat();
  // const isAtAnyPage = useCallback(() => {
  //   return PageLinks.some((pageLink) => pageLink.link === pathname);
  // }, [pathname]);

  const visible = useMemo(() => {
    return /^\/(\B|promotion|wallet|referral|profile|profile\/(deposit|withdrawal)|games(\w|\W)*)$/.test(pathname);
  }, [pathname]);

  return (
    <footer
      className={cn("bottom-0 left-0 right-0 z-50", "md:hidden", "container", {
        hidden: !visible,
        fixed: visible,
      })}
    >
      <div
        id="navbar-bottom"
        className={cn(
          "relative mx-auto h-[var(--bottom-navbar-height)] w-full max-w-[425px]",
          "z-50 mt-auto pb-0.5",
          "grid grid-cols-5",
          "items-center justify-center"
        )}
      >
        <Image
          src="/bottom-navbar/navigation_bar_frame.png"
          height={85}
          width={375}
          alt="Bottom Nav"
          className="absolute bottom-0 left-0 size-full drop-shadow-[0_-5px_5px_rgba(0,0,0,0.1)]"
        />
        {/* <Button
          as={motion.button}
          {...({
            initial: {
              x: "-200%",
              y: "-100%",
              opacity: 0,
            },
            animate: {
              x: visibility === "hidden" ? "0%" : "-200%",
              y: "-100%",
              opacity: visibility === "hidden" ? 1 : 0,
            },
            transition: {
              type: "spring",
            },
          } as MotionProps as any)}
          className={cn(
            "gradient-primary absolute left-0 top-0 z-[250] mb-[calc(4rem+24px)] ml-4 !size-12 -translate-y-full opacity-0 shadow-lg md:mb-4"
          )}
          isIconOnly
          radius="full"
          onPress={() => openLivechat()}
        >
          <LiveChat />
        </Button> */}
        {PageLinks.map((pageLink, index) => (
          <LinkItem
            key={index}
            imageLink={pageLink.imageLink}
            link={pageLink.link}
            text={pageLink.text}
            isMiddle={index === 2}
          />
        ))}
      </div>
    </footer>
  );
}
const LinkItem = ({
  imageLink,
  link,
  text,
  isMiddle = false,
}: {
  imageLink: string;
  link: string;
  text: string;
  isMiddle: boolean;
}) => {
  const pathname = usePathname();
  return (
    <Link href={link} className="relative flex size-full flex-col items-center justify-end gap-1 pb-1">
      <div
        className={cn("relative h-full", {
          "mb-4 w-10": isMiddle,
          "w-8": !isMiddle,
        })}
      >
        <Image
          src="/bottom-navbar/click_lighting.png"
          className={cn("left-0 aspect-[400/108] scale-[2] object-contain object-bottom", {
            hidden: pathname !== link,
            absolute: pathname === link,
            "-bottom-4": isMiddle,
            "-bottom-1": !isMiddle,
          })}
          alt="active"
          width={150}
          height={150}
        />
        <Image
          src={imageLink}
          className={cn(
            "absolute bottom-0 left-0 z-10 size-full object-contain object-bottom",
            isMiddle && "scale-[1.25]"
          )}
          alt={text}
          width={150}
          height={150}
        />
      </div>

      <span
        className={cn("text-xs sm:text-sm", {
          "bg-gradient-to-r from-[#FFEA92] via-[#C9A04C] to-[#FFFFA5] bg-clip-text font-bold text-transparent":
            pathname === link,
          "font-thin text-white/50": pathname !== link,
        })}
      >
        {text}
      </span>
    </Link>
  );
};
